import styled from "styled-components";
import Select from "react-select";

const selectStyles = ({ placeholderIsForcedToShown }) => ({
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgb(227,229,240)",
    border: "1px solid transparent",
    ":hover": {
      border: "1px solid #cacaca"
    }
  }),
  menuList: (styles) => ({
    ...styles,
    justifyContent: "flex-start!important"
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: "#181d2e",
    ":hover": {
      color: "#181d2e"
    }
  }),
  placeholder: () => ({
    fontSize: 21,
    color: "rgb(51, 51, 51)",
    fontWeight: 500,
    fontFamily: '"Rubik", sans-serif'
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor: "#d0d5e7",
    fontFamily: '"Rubik", sans-serif',
    color: "#181d2e",
    hyphens: "auto",
    fontWeight: "500",
    textOverflow: "initial",
    whiteSpace: "nowrap",
    display: placeholderIsForcedToShown ? "none" : styles.display,

    ":before": {
      backgroundColor: data.color || "transparent",
      borderRadius: 10,
      content: '" "',
      display: data.color ? "block" : "none",
      marginLeft: 8,
      height: 10,
      width: 10,
      marginTop: 8
    },
    div: {
      fontSize: "18px"
    }
  }),
  option: (styles, { data }) => ({
    ...styles,
    display: "flex",
    flexDirection: "row!important",
    justifyContent: "flex-start!important",
    fontSize: 13,
    fontFamily: "Rubik, sans-serif",
    ":before": {
      backgroundColor: data.color || "transparent",
      borderRadius: 10,
      content: '" "',
      display: "block",
      marginRight: 8,
      minHeight: 10,
      minWidth: 10,
      marginTop: 5
    }
  })
});

export const SelectStyled = styled(Select).attrs(({ placeholderIsForcedToShown }) => ({
  styles: selectStyles({ placeholderIsForcedToShown })
}))`
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Label = styled.label`
  color: rgb(179, 185, 205);
  font-size: 1.5rem;
  font-weight: 500;
  font-family: "Rubik", sans-serif;
  line-height: 38px;
  margin-right: 20px;
  white-space: nowrap;
`;

export const SelectContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const AlternativePlaceholder = styled.span`
  font-size: 21px;
  color: rgb(51, 51, 51);
  font-weight: 500;
  font-family: "Rubik", sans-serif;
  position: absolute;
  margin-top: -30px;
  margin-left: 8px;
  pointer-events: none;
`;
